<!--
Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.
-->
<div [ngClass]="{'password-change-container':!loggedIn}">

  <sita-header *ngIf="!loggedIn"></sita-header>

  <div class="password-change bento-box-container" [ngClass]="{'new-user-password-change': !loggedIn}">

    <div class="container mt-3">
      <div class="container-fluid w-100 p-1">
        <div class="page-header-container mt-2">
          <h4 class="table-page-title">Change password</h4>
          <p *ngIf="!loggedIn">
            As a security measure please change your password to proceed.
          </p>
        </div>
        <hr class="vertical-divider">
        <div class="changepassword-body d-flex justify-content-center p-2">
          <div class="changepassword-input d-flex flex-column align-items-start justify-content-center">
            <form [formGroup]="changePasswordForm" (ngSubmit)="changePasswordSubmit()"
              class="d-flex flex-column password-change-form w-100 form-container" autocomplete="off">

              <div class="px-4 mb-2" *ngIf="showHttpAlert">
                <sita-alerts [message]="httpErrorMsg" [alertType]="'error'" (close)="closeHttpAlert()">
                </sita-alerts>
              </div>

              <div class="px-4 mb-2" *ngIf="showSimilarPasswordAlert">
                <sita-alerts [message]="constants.ERROR_MSG.CURRENT_NEW_PSWD_SAME" [alertType]="'error'"
                  (close)="closeSimilarPasswordAlert()">
                </sita-alerts>
              </div>

              <div class="d-flex form-field-container">
                <mat-label class="field-label text-start px-4"
                  [ngClass]="{'error-label': currentPasswordFormField?.dirty && currentPasswordFormField?.value?.length === 0}">Current
                  password</mat-label>
                <mat-form-field class="px-4 flex-grow-1 mb-0" appearance="outline" subscriptSizing="dynamic">
                  <input matInput name="currentPassword" formControlName="currentPassword"
                    [type]="showCurrentPassword ? 'text':'password'" class="pe-2" />
                  <img
                    [src]="showCurrentPassword ? 'assets/icons/visibility-on.svg' : 'assets/icons/visibility-off.svg' "
                    alt="eye" role="button" (click)="showCurrentPassword = !showCurrentPassword" />
                  <mat-error class="form-field-error-text"
                    *ngIf="currentPasswordFormField?.dirty && currentPasswordFormField?.value?.length === 0">Field is
                    required</mat-error>
                </mat-form-field>

              </div>

              <div class="d-flex form-field-container">
                <mat-label class="field-label text-start px-4"
                  [ngClass]="{'error-label': newPasswordFormField?.invalid && newPasswordFormField?.dirty}">New
                  password</mat-label>
                <mat-form-field class="px-4 mb-0 flex-grow-1" appearance="outline" subscriptSizing="dynamic">
                  <input matInput name="newPassword" formControlName="newPassword"
                    [type]="showPassword ? 'text':'password'" class="pe-2" />
                  <img [src]="
                  showPassword
                    ? 'assets/icons/visibility-on.svg'
                    : 'assets/icons/visibility-off.svg'
                " alt="eye" role="button" (click)="togglePasswordVisibility()" />
                  <mat-error class="form-field-error-text"
                    *ngIf="newPasswordFormField?.dirty && newPasswordFormField?.value?.length === 0 && (newPasswordFormField?.touched || newPasswordFormField?.dirty)">Field
                    is
                    required</mat-error>
                  <mat-error class="form-field-error-text"
                    *ngIf="newPasswordFormField?.errors?.['pattern'] && (newPasswordFormField?.touched || newPasswordFormField?.dirty) && !newPasswordFormField?.errors?.['minlength']">Password
                    does not meet criteria</mat-error>
                </mat-form-field>
              </div>
              <div class="d-flex form-field-container">
                <mat-label class="field-label text-start px-4"
                  [ngClass]="{'error-label': (confirmPasswordFormField?.invalid && (confirmPasswordFormField?.dirty)) || (changePasswordForm.errors?.['mismatch'] && confirmPasswordFormField?.dirty)}">Confirm
                  password</mat-label>
                <mat-form-field class="px-4 mb-0 flex-grow-1" appearance="outline" subscriptSizing="dynamic">
                  <input matInput name="confirmPassword" formControlName="confirmPassword" type="password"
                    class="pe-2" />
                  <mat-error class="form-field-error-text"
                    *ngIf="confirmPasswordFormField?.errors?.['passwordMismatch'] && (confirmPasswordFormField?.touched || confirmPasswordFormField?.dirty)">Passwords
                    do not match</mat-error>
                  <mat-error class="form-field-error-text"
                    *ngIf="confirmPasswordFormField?.dirty && confirmPasswordFormField?.value?.length === 0">Field is
                    required</mat-error>
                </mat-form-field>
              </div>
              <div class="px-4">
                <button [disabled]="changePasswordForm.invalid" mat-raised-button color="primary my-2"
                  class="primary-button w-100" type="submit">
                  Change password
                </button>
              </div>
            </form>
          </div>
          <div class="text-container d-flex">
            <div class="pswdrules">
              <div class="subheader mb-3">
                <h6 class="table-subheader-text">Password rules</h6>
              </div>
              <div class="rulelist">
                <ul class="rule-list">
                  <li [ngClass]="{
                    'text-success':
                      newPasswordFormField?.value?.match('^(?=.*[A-Z])'),
                    'rule-not-met': newPasswordFormField?.value && !newPasswordFormField?.value?.match('^(?=.*[A-Z])')
                  }">
                    <span class="rule-icon">
                      <img *ngIf="newPasswordFormField?.value?.match('^(?=.*[A-Z])')" src="assets/icons/check.svg"
                        alt="check" />
                      <img *ngIf="!newPasswordFormField?.value?.match('^(?=.*[A-Z])')" src="assets/icons/close.svg"
                        alt="close" />
                    </span>
                    <span>At least one uppercase letter (A–Z)
                    </span>
                  </li>
                  <li [ngClass]="{
                    'text-success':
                      newPasswordFormField?.value?.match('(?=.*[a-z])'),
                    'rule-not-met': newPasswordFormField?.value && !newPasswordFormField?.value?.match('(?=.*[a-z])')
                  }">
                    <span class="rule-icon">
                      <img *ngIf="newPasswordFormField?.value?.match('(?=.*[a-z])')" src="assets/icons/check.svg"
                        alt="check" />
                      <img *ngIf="!newPasswordFormField?.value?.match('(?=.*[a-z])')" src="assets/icons/close.svg"
                        alt="close" />
                    </span>
                    <span>At least one lowercase letter (a–z)</span>
                  </li>
                  <li [ngClass]="{
                    'text-success':
                      newPasswordFormField?.value?.match('(.*[0-9].*)'),
                    'rule-not-met': newPasswordFormField?.value && !newPasswordFormField?.value?.match('(.*[0-9].*)')
                  }">
                    <span class="rule-icon">
                      <img *ngIf="newPasswordFormField?.value?.match('(.*[0-9].*)')" src="assets/icons/check.svg"
                        alt="check" />
                      <img *ngIf="!newPasswordFormField?.value?.match('(.*[0-9].*)')" src="assets/icons/close.svg"
                        alt="close" />
                    </span>
                    <span>
                      At least one number (0–9)
                    </span>
                  </li>
                  <li [ngClass]="{
                    'text-success':
                      newPasswordFormField?.value?.match('(?=.*[!@#$%^&*])'),
                    'rule-not-met': newPasswordFormField?.value && !newPasswordFormField?.value?.match('(?=.*[!@#$%^&*])')
                  }">
                    <span class="rule-icon">
                      <img *ngIf="newPasswordFormField?.value?.match('(?=.*[!@#$%^&*])')" src="assets/icons/check.svg"
                        alt="check" />
                      <img *ngIf="!newPasswordFormField?.value?.match('(?=.*[!@#$%^&*])')" src="assets/icons/close.svg"
                        alt="close" />
                    </span>
                    <span>
                      At least one special character (!, $, %)
                    </span>

                  </li>
                  <li [ngClass]="{
                    'text-success': newPasswordFormField?.value?.match('.{8,}'),
                    'rule-not-met': newPasswordFormField?.value && !newPasswordFormField?.value?.match('.{8,}')
                  }">
                    <span class="rule-icon">
                      <img *ngIf="newPasswordFormField?.value?.match('.{8,}')" src="assets/icons/check.svg"
                        alt="check" />
                      <img *ngIf="!newPasswordFormField?.value?.match('.{8,}')" src="assets/icons/close.svg"
                        alt="close" />
                    </span>
                    <span>
                      Minimum 8 characters
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
